<template>
  <div
    :class="`dialog-box ${theme}`"
    class="dialog-primary"
    ref="dialogRef">
    <div
      class="dialog-header"
      @mousedown="handleDragStart">
      <span class="title" title="渲染优先级">渲染优先级</span>
      <!-- <div>
        <el-tooltip
          placement="top-start"
          popper-class="common-panel-tooltip-box"
          
        >
          <div slot="content">
            <a href="http://developer.bjblackhole.com/#/demo" class="link">
              前往开发者中心
            </a>
          </div>
          <div class="icon-box">
            <icon-svg icon-class="ic-wenhao1" class="icon" />
          </div>
        </el-tooltip>
      </div> -->
      <div class="dialog-primary-header-icon">
        <span
          class="icon"
          @click="handleCloseDialog">
          <i class="el-icon-close"></i>
        </span>
      </div>
    </div>
    <div class="dialog-content">
      <div class="instruction-box">
        请选择共面闪烁的构件，为其设置渲染优先级（支持ctrl多选）
      </div>
      <div class="item-box">
        <div class="name dialog-label">设置：</div>
        <div class="select-box">
          <el-select
            class="primary-select"
            v-model="currPriority"
            size="small"
            :popper-append-to-body="false"
            placeholder="请为选中的构件设置优先级">
            <el-option
              v-for="(item, index) in coplaneList"
              :key="index"
              :value="item.level"
              :label="item.label">
              <div
                @click="handleCoplaneClick(item.level)"
                class="select-item">
                {{ item.label }}
              </div>
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="item-box">
        <div class="name dialog-label">查看：</div>
        <div class="select-box">
          <el-select
            class="primary-select"
            v-model="viewPriority"
            size="small"
            :popper-append-to-body="false"
            placeholder="查看已设置优先级的构件">
            <el-option
              v-for="(item, index) in priorityList"
              :key="index"
              :value="item.level"
              :label="`${item.label}（${item.total}）`">
              <div
                class="select-item"
                @click="handleViewCoplaneClick(item.level)">
                {{ `${item.label}（${item.total}）` }}
              </div>
            </el-option>
          </el-select>
        </div>
        <div
          class="button-box"
          v-if="isResetVisible()">
          <el-button
            type="text"
            class="normal-btn"
            @click="resetCoplane"
            >重置</el-button
          >
        </div>
      </div>
      <div class="tips-box">
        <div v-if="publishStatus !== 'Complete' && publishStatus !== 'Init'">
          <i class="el-icon-warning icon"></i>
          上次编辑的数据未保存，可点击保存按钮进行保存
        </div>
      </div>
    </div>
    <div class="dialog-footer common-button-box btn-group-primary">
      <el-button
        size="small"
        class="negative hollowOut-btn primary-ang-btn gr9"
        @click="resetAll"
        title="将所有构件重置为默认层级"
        >全部重置</el-button
      >
      <el-button
        type="primary"
        class="primary-ang-btn primary-btn"
        size="small"
        @click="publishCoplane"
        >保存</el-button
      >
    </div>
  </div>
</template>

<script>
import { Loading } from 'element-ui'

import {
  coplaneListService,
  getCoplaneStatusService,
  saveCoplaneService,
  resetCoplaneService,
  publishCoplaneService,
  giveUpCoplaneService
} from '@/service/interface'
export default {
  data() {
    return {
      currPriority: undefined,
      coplaneList: [
        {
          label: '置于顶层',
          level: '-0.000002'
        },
        {
          label: '置于次顶层',
          level: '-0.000001'
        },
        {
          label: '默认层级',
          level: '0'
        },
        {
          label: '置于次底层',
          level: '0.000001'
        },
        {
          label: '置于底层',
          level: '0.000002'
        }
      ],
      viewPriority: undefined,
      priorityList: [
        {
          label: '顶层',
          level: '-0.000002',
          total: 0,
          elementIds: []
        },
        {
          label: '次顶层',
          level: '-0.000001',
          total: 0,
          elementIds: []
        },
        {
          label: '次底层',
          level: '0.000001',
          total: 0,
          elementIds: []
        },
        {
          label: '底层',
          level: '0.000002',
          total: 0,
          elementIds: []
        }
      ],
      publishStatus: 'Complete',
      publishFailFlag: false
    }
  },
  props: {
    theme: String,
    closeDialog: Function
  },
  mounted() {
    const BlackHole3D = window.BlackHole3D
    BlackHole3D.BIM.delAllSelElems()

    this.init().then(() => {
      this.setElemPriority()
    })

    document.addEventListener('mousemove', this.onMouseMove)
    document.addEventListener('mouseup', this.onMouseUp)
  },
  beforeDestroy() {
    document.removeEventListener('mousemove', this.onMouseMove)
    document.removeEventListener('mouseup', this.onMouseUp)
  },
  methods: {
    init() {
      return new Promise(resolve => {
        this.queryCoplaneList().then(response => {
          this.getCoplaneStatus().then(status => {
            let priorityList = this.priorityList
            response.forEach(item => {
              let find = priorityList.find(el => el.level === item.level)
              if (find) {
                find.elementIds = item.elementIds
              }
            })
            priorityList.forEach(item => {
              item.total = item.elementIds.length
            })
            this.priorityList = priorityList

            this.publishStatus = status
            resolve()
          })
        })
      })
    },
    handleCoplaneClick(level) {
      const BIM = window.BlackHole3D.BIM
      let elemIds = BIM.getSelElemIDs()
      if (!elemIds.length) {
        this.$message.warning('请先选择构件')
        return
      }

      let elements = elemIds[0].elemIdList
      let dataSetId = this.$route.query.datasetId
      let params = { dataSetId, level, elements }
      BIM.setElemDepthBias(dataSetId, elements, level)
      saveCoplaneService(params).then(response => {
        if (response.isSuccess) {
          this.uodatePriorityList().then(() => {
            dataSetId = dataSetId.replaceAll('-', '')
            BIM.setElemDepthBias(dataSetId, elements, level)
            this.$message.success('设置成功')

            this.clearForm()
          })
        } else {
          this.$message.error(response.errMsg)
        }
      })
    },
    handleViewCoplaneClick(level) {
      let priorityList = this.priorityList
      let find = priorityList.find(el => el.level === level)

      const BlackHole3D = window.BlackHole3D
      BlackHole3D.BIM.delAllSelElems()
      if (!find.total) return

      let color = new BlackHole3D.REColor(255, 144, 0, 200)
      BlackHole3D.BIM.setSelElemsClr(color)

      let dataSetId = this.$route.query.datasetId
      dataSetId = dataSetId.replaceAll('-', '')
      BlackHole3D.BIM.addToSelElems(dataSetId, find.elementIds)
    },
    resetAll() {
      let message = '确定要将所有渲染层级下的构件重置到默认层级吗？'
      this.$confirm(message, '提示', {
        customClass: `${this.theme === 'light' ? 'common-msg-box' : ''}`,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = Loading.service({
            text: '数据重置中......',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })

          let dataSetId = this.$route.query.datasetId
          let params = { dataSetId, level: '' }
          resetCoplaneService(params).then(response => {
            dataSetId = dataSetId.replaceAll('-', '')
            window.BlackHole3D.BIM.setElemDepthBias(dataSetId, [], 0)
            if (response.isSuccess) {
              this.uodatePriorityList().then(() => {
                this.$message.success('重置成功')
                this.clearForm()

                this.loading && this.loading.close()
                this.loading = null
                if (window.isMinIO) {
                  window.location.reload()
                }
              })
            } else {
              this.$message.error(response.errMsg)
              this.loading && this.loading.close()
              this.loading = null
            }
          })

          // 防止出现异常问题(网络断开、请求超时等)时，加载弹窗不销毁的情况
          setTimeout(() => {
            if (this.loading) {
              this.$message.error('请求超时，请稍后重试')
              this.loading && this.loading.close()
              this.loading = null
            }
          }, window.commonTimeout)
        })
        .catch(() => {
          this.$message.info('取消重置')
        })
    },
    resetCoplane() {
      let priorityList = this.priorityList
      let find = priorityList.find(el => el.level === this.viewPriority)
      let message = `确定要将置于【${find.label}】的所有构件重置到默认层级吗？`
      this.$confirm(message, '提示', {
        customClass: `${this.theme === 'light' ? 'common-msg-box' : ''}`,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = Loading.service({
            text: '数据重置中......',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })

          let dataSetId = this.$route.query.datasetId
          let params = { dataSetId, level: this.viewPriority }
          resetCoplaneService(params).then(response => {
            if (find) {
              let elementIds = find.elementIds
              dataSetId = dataSetId.replaceAll('-', '')
              window.BlackHole3D.BIM.setElemDepthBias(dataSetId, elementIds, 0)
            }
            if (response.isSuccess) {
              this.uodatePriorityList().then(() => {
                this.$message.success('重置成功')

                this.clearForm()
                this.loading && this.loading.close()
                this.loading = null

                if (window.isMinIO) {
                  window.location.reload()
                }
              })
            } else {
              this.$message.error(response.errMsg)
              this.loading && this.loading.close()
              this.loading = null
            }
          })

          // 防止出现异常问题(网络断开、请求超时等)时，加载弹窗不销毁的情况
          setTimeout(() => {
            if (this.loading) {
              this.$message.error('请求超时，请稍后重试')
              this.loading && this.loading.close()
              this.loading = null
            }
          }, window.commonTimeout)
        })
        .catch(() => {
          this.$message.info('取消重置')
        })
    },
    uodatePriorityList() {
      return new Promise(resolve => {
        this.queryCoplaneList().then(response => {
          let priorityList = this.priorityList
          priorityList.forEach(item => {
            let find = response.find(el => el.level === item.level)
            if (find) {
              item.elementIds = find.elementIds
            } else {
              item.elementIds = []
            }
          })

          priorityList.forEach(item => {
            item.total = item.elementIds.length
          })
          this.priorityList = priorityList
          resolve()
        })
      })
    },
    queryCoplaneList() {
      return new Promise(resolve => {
        let dataSetId = this.$route.query.datasetId
        coplaneListService({ dataSetId }).then(response => {
          if (response.isSuccess) {
            resolve(response.data)
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    getCoplaneStatus() {
      return new Promise(resolve => {
        let dataSetId = this.$route.query.datasetId
        getCoplaneStatusService({ dataSetId }).then(response => {
          if (response.isSuccess) {
            resolve(response.data)
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    publishCoplane() {
      return new Promise(resolve => {
        this.loading = Loading.service({
          text: '数据保存中......',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        let dataSetId = this.$route.query.datasetId
        publishCoplaneService({ dataSetId }).then(response => {
          if (response.isSuccess) {
            this.getCoplaneStatus().then(status => {
              if (status === 'Complete' || status === 'Init') {
                this.publishStatus = status
                this.$message.success('保存成功')
                this.loading && this.loading.close()
                this.loading = null
                if (window.isMinIO) {
                  window.location.reload()
                }
                resolve()
              }
            })
          } else {
            this.publishFailFlag = true
            this.loading && this.loading.close()
            this.loading = null
            this.$message.error('保存失败，请检查数据或服务是否存在异常')
          }
        })

        // 防止出现异常问题(网络断开、请求超时等)时，加载弹窗不销毁的情况
        setTimeout(() => {
          if (this.loading) {
            this.$message.error('请求超时，请稍后重试')
            this.loading && this.loading.close()
            this.loading = null
          }
        }, window.commonTimeout)
      })
    },
    isResetVisible() {
      let priorityList = this.priorityList
      let find = priorityList.find(el => el.level === this.viewPriority)
      if (find && find.total) {
        return true
      } else {
        return false
      }
    },
    setElemPriority() {
      let priorityList = this.priorityList
      let dataSetId = this.$route.query.datasetId
      dataSetId = dataSetId.replaceAll('-', '')

      const BIM = window.BlackHole3D.BIM
      priorityList.forEach(item => {
        if (item.elementIds.length) {
          BIM.setElemDepthBias(dataSetId, item.elementIds, item.level)
        }
      })
    },
    handleCloseDialog() {
      return new Promise(resolve => {
        if (this.publishFailFlag) {
          this.closeDialog()
          resolve(true)
          return
        }

        this.getCoplaneStatus().then(status => {
          if (status === 'Complete' || status === 'Init') {
            this.closeDialog()
            resolve(true)
          } else {
            let message = '当前有数据未保存，系统将为您自动保存，确认要退出吗？'
            this.$confirm(message, '提示', {
              customClass: `${this.theme === 'light' ? 'common-msg-box' : ''}`,
              distinguishCancelAndClose: true,
              confirmButtonText: '确定',
              cancelButtonText: '放弃',
              type: 'warning'
            })
              .then(() => {
                this.publishCoplane().then(() => {
                  this.closeDialog()
                  resolve(true)
                })
              })
              .catch(action => {
                if (action === 'cancel') {
                  let dataSetId = this.$route.query.datasetId
                  giveUpCoplaneService({ dataSetId }).then(response => {
                    if (response.isSuccess) {
                      this.closeDialog()
                      resolve(true)
                    } else {
                      this.$message.error(response.errMsg)
                    }
                  })
                }
              })
          }
        })
      })
    },
    clearForm() {
      this.currPriority = undefined
      window.BlackHole3D.BIM.delAllSelElems()
    },

    handleDragStart(e) {
      e.target.style.cursor = 'move'
      this.originTop = e.target.offsetParent.offsetTop
      this.originLeft = e.target.offsetParent.offsetLeft
      this.originX = e.clientX
      this.originY = e.clientY
      this.isMouseDown = true
    },
    onMouseMove(event) {
      if (!this.isMouseDown) return false
      let deltaX = event.clientX - this.originX
      let deltaY = event.clientY - this.originY
      let activeElement = document.activeElement
      let maxLeft = activeElement.offsetWidth - this.$refs.dialogRef.offsetWidth
      let maxTop =
        activeElement.offsetHeight - this.$refs.dialogRef.offsetHeight
      let top = deltaY + this.originTop
      let left = deltaX + this.originLeft
      if (left > maxLeft) return false
      if (top > maxTop) return false
      if (top <= 0) return false
      if (left <= 0) return false

      let dialogRef = this.$refs.dialogRef
      dialogRef.style.top = `${top}px`
      dialogRef.style.left = `${left}px`
    },
    onMouseUp(e) {
      if (!this.isMouseDown) return false
      this.isMouseDown = false
      e.target.style.cursor = 'default'
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.light {
  .dialog-header {
    color: var(--dialog-header-icon-color);
    background: var(--base-bg-dark-color28);
    align-items: center;

    .title{
      color: var(--dialog-header-text-color);
    }

    .dialog-primary-header-icon {
      .icon {
        align-items: center;
        justify-content: center;
        width: 24px;
        height: 24px;
        &:hover {
          width: 24px;
          height: 24px;
          border-radius: 4px;
          .el-icon-close {
            line-height: 14px;
          }
        }
      }
    }
  }
  .instruction-box {
    color: var(--base-dark9-color);
  }

  .select-box {
    flex: 1;
    :deep(.el-select) {
      width: 100%;

      .el-input__inner {
        width: 100%;
      }
    }
  }

  .dialog-footer {
    padding: 10px;
    justify-content: flex-end;
  }
}

.dark {
  color: var(--default-color);
  background: var(--base-bg-dark-color13);

  .dialog-header {
    background: var(--base-bg-light-color7);

    .icon {
      background: var(--base-bg-light-color7);
    }
  }

  .instruction-box {
    color: var(--base-border-dark-color12);
  }

  .dialog-footer {
    padding: 10px;
    border: 1px solid var(--base-border-dark-color14);
    text-align: right;

    .negative {
      color: var(--base-light-color8);
      background: var(--base-bg-dark-color13);
      border: 1px solid var(--base-light-color8);
    }
  }
}

.dialog-box {
  position: absolute;
  top: 150px;
  right: 20px;
  width: 450px;
  text-align: left;
  z-index: 3;
  border-radius: 16px;
  background: var(--dialog-bgColor);
  box-shadow: var(--base-bg-dark-color30);
  overflow: visible;

  .dialog-header {
    display: flex;
    justify-content: space-between;
    height: 40px;
    padding: 10px 20px;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;

    .icon {
      display: flex;
      margin: auto 0px;
      cursor: pointer;

      &:hover {
        background: var(--base-bg-dark-color4);
      }
    }
  }

  .dialog-content {
    padding: 16px;
    padding-top: 0;
    .instruction-box {
      font-size: 12px;
      height: 32px;
      line-height: 32px;
      color: var(--page-tips-text-color);
      margin-left: -16px;
      margin-right: -16px;
      padding-left: 16px;
      padding-right: 16px;
    }
    .item-box {
      display: flex;
      line-height: 32px;
      margin-bottom: 5px;

      .name {
        font-size: 14px;
      }

      .select-item {
        padding: 0px 20px;
      }

      .button-box {
        margin-left: 10px;

        .icon {
          margin-left: 2px;
          font-size: 13px;
          color: var(--base-light-color9);
        }
      }
    }
    .tips-box {
      color: var(--base-dark9-color);
      font-size: 13px;
      margin-top: 10px;
      margin-left: 50px;

      .icon {
        color: var(--base-light-color10);
      }
    }
  }
}
</style>
